let resumeData = {
    "name": "Daniel Bardsley",
    "role": "Chief Engineer at BJSS",
    "linkedinId": "https://www.linkedin.com/in/dbardsley/",
    "roleDescription": "Chief Engineer at BJSS: Full Stack Developer, Architect and Leader with expertise in Cloud, DevOps and Data Engineering",
    "socialLinks": [
        {
            "name": "linkedin",
            "url": "https://www.linkedin.com/in/dbardsley/",
            "className": "fa fa-linkedin"
        },
        {
            "name": "github",
            "url": "https://github.com/danielbardsley",
            "className": "fa fa-github"
        }
    ],
    "aboutme": "Originally from the UK I now reside in Jersey City, USA. I studied Computer Science at the University of Nottingham " +
        "before starting work at BJSS in 2008 in their Leeds headquarters. After also working some time based out of London " +
        "I took a 6 month secondment to help setup the BJSS New York office and after 7 years I'm still here. I enjoy playing soccer, " +
        "love music and all things technical.",
    "address": "Jersey City, New Jersey",
    "website": "https://bardsley.io",
    "email": "daniel@bardsley.io",
    "education": [
        {
            "UniversityName": "University of Nottingham, UK",
            "specialization": "PhD in Computer Science",
            "MonthOfPassing": "Sep",
            "YearOfPassing": "2008"
        },
        {
            "UniversityName": "University of Nottingham, UK",
            "specialization": "Batchelor of Engineering in Computer Science",
            "MonthOfPassing": "Sep",
            "YearOfPassing": "2004"
        }
    ],
    "publications": [
        {
            "title": "Low-Latency Trading over RoCE V2 on Oracle Cloud Infrastructure",
            "journal": "IEEE International Conference on Cloud Networking",
            "year": "2023"
        },
        {
            "title": "Low-latency Trading in the Cloud Environment",
            "journal": "IEEE International Conference on Computational Science and Engineering",
            "year": "2019"
        },
        {
            "title": "Serverless Performance and Optimization Strategies",
            "journal": "IEEE International Conference on Smart Cloud",
            "year": "2018"
        },
        {
            "title": "A Practical Framework for 3D reconstruction and its Applications",
            "journal": "University of Nottingham PhD Thesis",
            "year": "2009"
        },
        {
            "title": "3D Surface Reconstruction and Recognition",
            "journal": "Biometric Technology for Human Identification IV",
            "year": "2007"
        },
        {
            "title": "Gabor Feature Selection for Face Recognition Using Improved AdaBoost Learning",
            "journal": "International Workshop on Biometric Person Authentication",
            "year": "2005"
        }
    ],
    "resumeSummary": "Daniel has worked for over 15 years at BJSS as a technical consultant spanning technology stacks, " +
        "industries and roles. The clients outlined below represent a subset of the projects he has contributed to since " +
        "he started work at BJSS. The work spans full stack technical delivery, architecture, team leadership and client " +
        "management. He has worked in a variety of industries including finance, retail, healthcare and sports betting.",
    "work": [
        {
            "CompanyName": "BJSS",
            "specialization": "Chief Engineer",
            "employmentPeriod": "Nov 2021 - Present",
            "Achievements": "Daniel is currently the chief engineer for BJSS' US operations. He is responsible for technical " +
                "quality across all US projects, including overall business strategy, architecture, design and delivery. " +
                "Daniel is as comfortable working hands on with clients delivering high quality engineering as he is contributing " +
                "to management decisions within the company."
        },
        {
            "CompanyName": "International Sports Betting Company",
            "specialization": "Engagement Lead",
            "employmentPeriod": "Nov 2018 - Present",
            "Achievements": "Acted as engagement lead on development and delivery of one of the first online sports betting " +
                "applications in the United States, overseeing the smooth running of a team of 15 developers distributed throughout the " +
                "clients technical teams. Oversaw the delivery of multiple components including, front end, API Layers, " +
                "backend Scala microservices and associated infrastructure. The system was required to be performant and " +
                "scaleable enough to handle large spiky traffic patterns, configurable enough handle multi-state deployments and " +
                "provide a user experience suitable to capture the fledgling American sports betting market. Extensive " +
                "regulatory requirements necessitated robust automated test suites to ensure the system could be deployed " +
                "after certification from the appropriate regulatory body."
        },
        {
            "CompanyName": "International Investment Bank",
            "specialization": "Technical Lead",
            "employmentPeriod": "Feb 2018 - Nov 2018",
            "Achievements": "Acted as a senior developer modernizing the funding and liquidity projection platform. " +
                "Implemented business critical improvements and re-platforming using a Java 8 stack and multiple proprietary " +
                "internal frameworks and tools. The funding projection platform was responsible for ingesting large quantities " +
                "of data from numerous sources, performing complex calculations and making the data available via a web " +
                "based interface."
        },
        {
            "CompanyName": "American Education Network",
            "specialization": "Technical Architect",
            "employmentPeriod": "May 2017 - Feb 2018",
            "Achievements": "Worked on a greenfield project to develop a personal virtual assistant able to guide students " +
                "through the college application process, their first weeks of higher education, and beyond. The team " +
                "developed a service-agnostic framework leveraging best of breed NLP engines, intent matching and sentiment " +
                "analysis to deliver intelligent conversations backed by multiple disparate big data sources. The mobile " +
                "centric system delivered rich content to the mobile application whilst integrating with a diverse set " +
                "of social media messaging providers.",
            "additionalAchievements":
                "A robust continuous integration platform was delivered to allow a multi-layered testing approach. Unit, " +
                "integration and UI tests were executed in the cloud on both virtual and physical devices. Extensive " +
                "integration tests were also executed against the restful backend running on Serverless infrastructure. " +
                "Combined with the Serverless Application Framework developers were able to create and execute against " +
                "clean software stacks which could be created on an ad-hoc basis in a matter of minutes allowing for the " +
                "delivery of cutting age business requirements in a highly productive environment."
        },
        {
            "CompanyName": "Nationwide Grocery Retailer",
            "specialization": "Technical Lead",
            "employmentPeriod": "Apr 2016 - May 2017",
            "Achievements": "Implemented a strategic upgrade to the clients e-commerce site replacing a heavyweight legacy " +
                "platform with a cloud based micro-service architecture. The architecture made extensive use or Amazon " +
                "Web Services to deliver a highly available, horizontally scalable e-commerce solution within a short " +
                "time frame. Utilising continuous integration / continuous deployment allowed for rapid development with " +
                "changes delivered directly to targeted customer segments in frequent iterations."
        },
        {
            "CompanyName": "International Investment Bank",
            "specialization": "Senior Developer",
            "employmentPeriod": "Sep 2015 - Mar 2016",
            "Achievements": "Worked as part of a high impact project team within the international investment bank to " +
                "develop a strategic replacement for their legacy trade processing system. The New Trade Processing System " +
                "harnessed the latest technologies and a black box, test driven approach to development in order to deliver " +
                "a system identical at the byte messaging level to its predecessor. Newt processes approximately 8 million " +
                "daily trades and reports to numerous downstream internal and external destinations in order to satisfy " +
                "a wide range of regulatory, compliance and business requirements.",
            "additionalAchievements":
                "The legacy system was comprised of a mainframe COBOL application developed over 3 decades with minimal " +
                "documentation and few resources available to describe the logical operation of the system. The black " +
                "box test driven approach allowed data to be extracted from the production environment and executed against " +
                "the system under development with results automatically compared, reported and integrated into the bespoke " +
                "test suite. A staged deployment to production in parallel with the legacy system allowed for a high degree " +
                "of confidence and minimal risk as existing input and output feeds were switched over to the new system."
        },
        {
            "CompanyName": "Nationwide Grocery Retailer",
            "specialization": "Technical Lead",
            "employmentPeriod": "Apr 2014 - Aug 2015",
            "Achievements": "Worked within a number of internal teams filling roles as both a senior developer and agile " +
                "consultant. The roles involved extensive performance improvements to the client’s primary commerce site. " +
                "Legacy code and architecture was re-factored alongside business as usual feature development to provide " +
                "a more robust and performant system based on the WebSphere Commerce platform. Acted as an agile consultant " +
                "in order to transition the company away from their traditional development practices and bring the " +
                "company in line with modern industry standards."
        },
        {
            "CompanyName": "National Health Organization",
            "specialization": "Technical Lead",
            "employmentPeriod": "Oct 2012 - Apr 2014",
            "Achievements": "Worked as a team lead tasked with delivering the replacement for a critical nationwide messaging " +
                "system for the NHS. A heavy focus on an open source software stack allowed for the development of a diverse " +
                "skill set encompassing python, nosql and a variety of supporting linux software. The team were integral " +
                "in developing a large, horizontally scalable system suitable for supporting the workflow of hundreds of " +
                "external companies and partners. In addition to the core messaging system the team also oversaw the " +
                "development of several web based user interfaces critical for interacting with system. The complete " +
                "system is currently responsible for reliable delivery of functionality critical to the smooth running " +
                "of the United Kingdom's healthcare infrastructure."
        }
    ],
    "skillsDescription": "Full Stack Architect, Developer and leader with expertise in Cloud, DevOps and Data Engineering",
    "skills": [
        {
            "skillname": "HTML5"
        },
        {
            "skillname": "CSS"
        },
        {
            "skillname": "Reactjs"
        }
    ],
    "portfolio": [
        {
            "name": "project1",
            "description": "mobileapp",
            "imgurl": "images/portfolio/coffee.jpg"
        },
        {
            "name": "project2",
            "description": "mobileapp",
            "imgurl": "images/portfolio/console.jpg"
        },
        {
            "name": "project3",
            "description": "mobileapp",
            "imgurl": "images/portfolio/retrocam.jpg"
        },
        {
            "name": "project4",
            "description": "mobileapp",
            "imgurl": "images/portfolio/origami.jpg"
        }
    ],
    "testimonials": [
        {
            "description": "This is a sample testimonial",
            "name": "Some technical guy"
        },
        {
            "description": "This is a sample testimonial",
            "name": "Some technical guy"
        }
    ]
}

export default resumeData